export default class Reporting {
    public id?: number;
    public name_fr?: string;
    public name_en?: string;
    public name_nl?: string;

    constructor(init?: Partial<Reporting>) {
        Object.assign(this, init);
    }
}